import * as actions from './actions';
import * as mutations from './mutations';
import * as getters from './getters';

class State {
    public isFetching: boolean = false;
    public allMappings: any[] = [];
    public allCategories: string[] = [];
}

export default {
    namespaced: true,
    state: new State(),
    mutations,
    actions,
    getters
};
